import React from 'react';
import { PropTypes } from 'prop-types';

const Title = ({ className, t, isRecurring }) => (
  <div className={className}>
    <h1>{t(`title${isRecurring ? '_recurring' : ''}`)}</h1>
    <h2>{t(`subtitle${isRecurring ? '_recurring' : ''}`)}</h2>
  </div>
);

Title.propTypes = {
  className: PropTypes.string,
  t: PropTypes.func,
  isRecurring: PropTypes.bool,
};

Title.defaultProps = {
  className: '',
  t: () => {},
  isRecurring: false,
};

export default Title;
